import { BasicLogger } from "@initia-digital/ts-utils";
import { IInitiaConnectContact } from "@initia-digital/types/contacts";


const logger = new BasicLogger({ logLevel: 0, logFormat: 'BROWSER' });

const API_DOMAIN = 'https://hi.api.initia-digital.co.nz';
const STAGE = `v1`;


// --------------------------------------------
//           CONTACTS SERVICE
// --------------------------------------------
export const postContact = async (contact: IInitiaConnectContact & { event: string }) => {
    // -----------------------------------
    try {
        const response = await fetch(`${API_DOMAIN}/${STAGE}/contacts`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': import.meta.env.VITE_CONNECT_API_KEY,
            },
            body: JSON.stringify({ ...contact }),
        });

        // ---------------------
        if (!response.ok) {
            throw new Error(`Failed to post contact: ${response.statusText}`);
        }

        // ---------------------
        return await response.json();
    } catch (error) {
        logger.error('Error posting contact', error);
        throw error;
    }
};

